import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_NOTESASSOCIATES,
  CREATE_NOTESASSOCIATES,
  DELETE_NOTESASSOCIATES,
  UPDATE_NOTESASSOCIATES,
} from "./actionType";

import {
  NotesAssociatesApiResponseSuccess,
  NotesAssociatesApiResponseError,
} from "./action";

import {
  getNotesAssociates as NotesAssociatesGet,
  createNotesAssociates as NotesAssociatesCreate,
  updateNotesAssociates as NotesAssociatesUpdate,
  deleteNotesAssociates as NotesAssociatesDelete,
} from "../../helpers/backend_helper";
import { notifyError, notifySuccess } from "../../components/notify";

function* getNotesAssociates(data) {
  try {
    const response = yield call(NotesAssociatesGet, data.payload);
    yield put(NotesAssociatesApiResponseSuccess(GET_NOTESASSOCIATES, response));
  } catch (error) {
    yield put(NotesAssociatesApiResponseError(GET_NOTESASSOCIATES, error));
  }
}

function* createNotesAssociates(data) {
  const dataRequest = {
    customer_id: data.payload.id,
    customer_note_type_id: data.payload.idNote,
    note: data.payload.note,
  };

  try {
    const response = yield call(NotesAssociatesCreate, dataRequest);
    yield put(
      NotesAssociatesApiResponseSuccess(CREATE_NOTESASSOCIATES, response)
    );
    notifySuccess("Nota de associado criada com sucesso!");
  } catch (error) {
    yield put(NotesAssociatesApiResponseError(CREATE_NOTESASSOCIATES, error));
    notifyError("Erro ao criar nota de associado!");
  }
}

function* updateNotesAssociates(data) {
  try {
    const response = yield call(NotesAssociatesUpdate, {
      id: data.payload.id,
      data: data.payload.data,
    });
    yield put(
      NotesAssociatesApiResponseSuccess(UPDATE_NOTESASSOCIATES, response)
    );
    notifySuccess("Nota de associado atualizada com sucesso!");
  } catch (error) {
    yield put(NotesAssociatesApiResponseError(UPDATE_NOTESASSOCIATES, error));
    notifyError("Erro ao atualizar nota de associado!");
  }
}

function* deleteNotesAssociates(data) {
  try {
    const response = yield call(NotesAssociatesDelete, data.payload.id);
    yield put(
      NotesAssociatesApiResponseSuccess(DELETE_NOTESASSOCIATES, response)
    );
    notifySuccess("Nota de associado deletada com sucesso!");
  } catch (error) {
    yield put(NotesAssociatesApiResponseError(DELETE_NOTESASSOCIATES, error));
    notifyError("Erro ao deletar nota de associado!");
  }
}

export function* watchGetNotesAssociates() {
  yield takeEvery(GET_NOTESASSOCIATES, getNotesAssociates);
}

export function* watchCreateNotesAssociates() {
  yield takeEvery(CREATE_NOTESASSOCIATES, createNotesAssociates);
}

export function* watchUpdateNotesAssociates() {
  yield takeEvery(UPDATE_NOTESASSOCIATES, updateNotesAssociates);
}

export function* watchDeleteNotesAssociates() {
  yield takeEvery(DELETE_NOTESASSOCIATES, deleteNotesAssociates);
}

function* NotesAssociatesSaga() {
  yield all([fork(watchGetNotesAssociates)]);
  yield all([fork(watchCreateNotesAssociates)]);
  yield all([fork(watchUpdateNotesAssociates)]);
  yield all([fork(watchDeleteNotesAssociates)]);
}

export default NotesAssociatesSaga;
